import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class StudentService {
  private baseUrl = 'http://localhost:8000/api';

  constructor(private http: HttpClient, private apiHelperService: ApiHelperService) {}

  getStudentDetails(studentId: number): Promise<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  
    return this.apiHelperService.getDataWithShortlistingUrl(`student/details/${studentId}/`);  
  }

  getStudentWishlist(studentId: number): Promise<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  
    return this.apiHelperService.getDataWithShortlistingUrl(`student/wishlist/${studentId}/`);  
  }
}
